<template>
  <footer class="footer p-5" v-if="!auth.iframeSrc">
    <div class="container">
      <div class="row">
        <div class="col">
          <p class="text-center small text-dark">
            <strong>C3 (Community Care Connection)</strong>
            by Justin Kline - Copyright &copy;
            {{ new Date().getFullYear() }}. All Rights Reserved -
            <a :href="`${publicPath}PrivacyPolicyC3.pdf`" target="_blank"
              >Privacy Policy</a
            >
            <strong> |</strong>
            <a :href="`${publicPath}TERMSANDCONDITIONSC3.pdf`" target="_blank">
              Terms & Conditions</a
            >
          </p>
          <p class="text-center">
            PIPEDA, PHIPA, &amp; HIPAA Compliant
            <span class="small">{{ new Date().getFullYear() }}</span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "FooterView",
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  computed: {
    ...mapState(["auth"]),
  },
};
</script>
